import React from "react";

// # GLOBAL NETWORK V2 · REPLAY: animate an explicit, frozen sample of recorded
// movements. Never present it as a historical reconstruction of account states.
export default function useNetworkPlayback(network, paused, setPaused) {
  const [session, setSession] = React.useState(null);
  const start = React.useCallback(() => {
    if (!network?.events?.length) return;
    const events = [...network.events].sort((a, b) => new Date(a.occurredAt) - new Date(b.occurredAt) || a.id.localeCompare(b.id));
    setSession({ snapshot: network, events, index: 0, revision: 0, playing: events.length > 1, wasPaused: paused });
    setPaused(true);
  }, [network, paused, setPaused]);
  const stop = React.useCallback(() => {
    if (!session) return;
    setPaused(session.wasPaused); setSession(null);
  }, [session, setPaused]);
  const seek = React.useCallback((index) => setSession((current) => current ? {
    ...current, index: Math.max(0, Math.min(current.events.length - 1, Number(index) || 0)), revision: current.revision + 1, playing: false,
  } : null), []);
  const toggle = React.useCallback(() => setSession((current) => current ? {
    ...current, index: !current.playing && current.index === current.events.length - 1 ? 0 : current.index,
    revision: current.revision + Number(!current.playing),
    playing: !current.playing,
  } : null), []);
  React.useEffect(() => {
    if (!session?.playing) return undefined;
    let timer;
    const schedule = () => {
      window.clearTimeout(timer);
      if (document.visibilityState === "hidden") return;
      timer = window.setTimeout(() => {
        setSession((current) => current ? {
          ...current, index: Math.min(current.index + 1, current.events.length - 1),
          playing: current.index + 1 < current.events.length - 1,
        } : null);
      }, 1800);
    };
    schedule(); document.addEventListener("visibilitychange", schedule);
    return () => { window.clearTimeout(timer); document.removeEventListener("visibilitychange", schedule); };
  }, [session?.playing, session?.index]);
  return { active: Boolean(session), snapshot: session?.snapshot, events: session?.events || [],
    index: session?.index || 0, revision: session?.revision || 0, current: session?.events?.[session.index] || null,
    playing: Boolean(session?.playing), start, stop, seek, toggle };
}
